import { ISubscription } from '@sdk/contracts';
import { useMemo } from 'react';
import { MultiSegmentProgress } from 'react-multi-segment-progress';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import {
  SubscriptionCardWrapper,
  CourseInfoWrapper,
  CourseName,
  CourseProgressWrapper,
  EmojiWrapper,
  ProgressBarWrapper,
  ProgressText
} from './SubscriptionCard.styles';

import { useMySubscriptions } from '@/store';

type Props = {
  subscription: ISubscription;
};

export const SubscriptionCard: React.FC<Props> = ({ subscription }) => {
  const { colors } = useTheme();
  const { selectedSubscription, setSelectedSubscription, setIsOpen } = useMySubscriptions();
  const navigateTo = useNavigate();
  const handleSelectSubscription = () => {
    setSelectedSubscription(subscription);
    navigateTo(`/subscription/summary?activeTab=course-content`);
    setIsOpen(false);
  };
  const isSelected = useMemo(
    () => selectedSubscription?._id === subscription._id,
    [selectedSubscription]
  );
  return (
    <SubscriptionCardWrapper $selected={isSelected} onClick={handleSelectSubscription}>
      <EmojiWrapper>
        <span role="img" aria-label={`${subscription.course.name} emoji`}>
          {subscription.course.emoji}
        </span>
      </EmojiWrapper>
      <CourseInfoWrapper>
        <CourseName>{subscription.course.name}</CourseName>
        <CourseProgressWrapper>
          <ProgressBarWrapper>
            <MultiSegmentProgress
              segments={[
                {
                  id: 'progress',
                  percentage: subscription.progress || 0,
                  color: colors.green6
                }
              ]}
              showTooltips={false}
              height={8}
              borderRadius={8}
              backgroundColor={colors.black3}
            />
          </ProgressBarWrapper>
          <ProgressText>{subscription.progress}%</ProgressText>
        </CourseProgressWrapper>
      </CourseInfoWrapper>
    </SubscriptionCardWrapper>
  );
};
